export const assessmentTemplate = [
  {
    _id: "omniBusinessAssessment",
    omniAudit: {
      auditVersion: "1",
      omniRevision: "1",
      omniSchema: "assessmentTemplate",
      omniSchemaVersion: "1",
      writtenBy: null,
      createdBy: "melissaadmin9999",
      createdDate: "2024-20-21T00:00:00Z",
      modifiedBy: "melissaadmin9999",
      modifiedDate: "2024-24-21T00:00:00Z",
      isActive: true,
    },
    omniData: {
      omniType: "omniBusinessAssessment",
      omniTypeVersion: 1,
      title: "Business Assessment",
      purpose: "Business Assessment to onboard Leaders",
      description:
        "The information you provide will help us understand your business needs. We use this to identify what areas could use the most guidance.",
      duration: "Around 5 minutes",
      directions: "Follow the onscreen instructions after you begin.",
      attribution: "",
      validated: "true",
      startDate: null,
      completeDate: null,
      selfAssessment: true,
      questions: [
        {
          omniID: "ba1",
          shortTitle: "subjectBusinessDuration",
          numberText: "1",
          text: "How long have you been in business?",
          subText: "",
          helpText: "",
          instructions: "",
          displayType: "button",
          multiSelectText: "false",
          answerOptions: [
            {
              value: "lessThanOneYear",
              text: "Less than one year",
              subText: "",
              helpText: "",
              nextQuestionID: "",
              isLast: false,
            },
            {
              value: "oneToThreeYears",
              text: "One to three years",
              subText: "",
              helpText: "",
              nextQuestionID: "",
              isLast: false,
            },
            {
              value: "threeToFiveYears",
              text: "Three to five years",
              subText: "",
              helpText: "",
              nextQuestionID: "",
              isLast: false,
            },
            {
              value: "fiveToTenYears",
              text: "Five to ten years",
              subText: "",
              helpText: "",
              nextQuestionID: "",
              isLast: false,
            },
            {
              value: "moreThanTenYears",
              text: "More than ten years",
              subText: "",
              helpText: "",
              nextQuestionID: "",
              isLast: false,
            },
          ],
          answerValue: null,
          answerDate: null,
        },
        {
          omniID: "ba2",
          shortTitle: "empireOSUtilization",
          numberText: "2",
          text: "To what extent do you already use Empire OS?",
          subText: "",
          helpText: "",
          instructions: "",
          displayType: "button",
          multiSelectText: "false",
          answerOptions: [
            {
              value: "none",
              text: "None",
              subText: "",
              helpText: "",
              nextQuestionID: "",
              isLast: false,
            },
            {
              value: "twentyToFiftyPercent",
              text: "20% to 50%",
              subText: "",
              helpText: "",
              nextQuestionID: "",
              isLast: false,
            },
            {
              value: "fiftyToSeventyPercent",
              text: "51% to 70%",
              subText: "",
              helpText: "",
              nextQuestionID: "",
              isLast: false,
            },
            {
              value: "seventyToNinetyPercent",
              text: "71% to 90%",
              subText: "",
              helpText: "",
              nextQuestionID: "",
              isLast: false,
            },
            {
              value: "overNiinetyPercent",
              text: "Over 90%",
              subText: "",
              helpText: "",
              nextQuestionID: "",
              isLast: false,
            },
          ],
          answerValue: null,
          answerDate: null,
        },
        {
          omniID: "ba3",
          shortTitle: "profitabilityDuration",
          numberText: "3",
          text: "How many consecutive quarters has the business been profitable?",
          subText: "",
          helpText: "",
          instructions: "",
          displayType: "button",
          multiSelectText: "false",
          answerOptions: [
            {
              value: "preRevenue",
              text: "Pre-Revenue",
              subText: "",
              helpText: "",
              nextQuestionID: "",
              isLast: false,
            },
            {
              value: "twoQuarters",
              text: "Two quarters",
              subText: "",
              helpText: "",
              nextQuestionID: "",
              isLast: false,
            },
            {
              value: "threeToSixQuarters",
              text: "Three to six quarters",
              subText: "",
              helpText: "",
              nextQuestionID: "",
              isLast: false,
            },
            {
              value: "sevenToTenQuarters",
              text: "Seven to ten quarters",
              subText: "",
              helpText: "",
              nextQuestionID: "",
              isLast: false,
            },
            {
              value: "moreThanTenQuarters",
              text: "More than ten quarters",
              subText: "",
              helpText: "",
              nextQuestionID: "",
              isLast: false,
            },
          ],
          answerValue: null,
          answerDate: null,
        },
        {
          omniID: "ba4",
          shortTitle: "processDocumentationPercent",
          numberText: "4",
          text: "To what extent are your processes documented?",
          subText: "",
          helpText: "",
          instructions: "",
          displayType: "button",
          multiSelectText: "false",
          answerOptions: [
            {
              value: "lessThanFiftyPercent",
              text: "Less than 50%",
              subText: "",
              helpText: "",
              nextQuestionID: "",
              isLast: true,
            },
            {
              value: "fiftyToEightyPercent",
              text: "51% to 80%",
              subText: "",
              helpText: "",
              nextQuestionID: "",
              isLast: true,
            },
            {
              value: "eightyToNinetyPercent",
              text: "81% to 90%",
              subText: "",
              helpText: "",
              nextQuestionID: "",
              isLast: true,
            },
            {
              value: "oneHundredPercent",
              text: "100%",
              subText: "",
              helpText: "",
              nextQuestionID: "",
              isLast: true,
            },
            {
              value: "oneHundredPercentAndLean",
              text: "100% and follows lean principles",
              subText: "",
              helpText: "",
              nextQuestionID: "",
              isLast: true,
            },
          ],
          answerValue: null,
          answerDate: null,
        },
      ],
      assessmentResults: { finalResult: null },
    },
  },
];
export const assessmentScoring = [
  {
    typeID: "phq9",
    algorithms: [
      {
        name: "sum",
        minScore: 0,
        maxScore: 0,
        formula: null,
        questions: [],
      },
    ],
  },
];
